import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  useNavigate,
} from "react-router-dom";

import profilePic from "./assets/profile.JPG";
import foodwebimg from "./assets/foodweb.png";
import weathermimg from "./assets/weatherm.jpg";
import resume from "./assets/resume.pdf";
import cccyber from "./assets/cccyber.png";
import cc from "./assets/cc.png";
import off from "./assets/off.png";
import atmimg from "./assets/atmimg.png";



import { FaBars, FaTimes } from "react-icons/fa";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
  FaPhoneAlt,
  FaGithub,
  FaInstagram,
  FaChevronRight,
  FaLinkedin,
  FaWhatsapp,  
} from "react-icons/fa";

import { SiTryhackme } from "react-icons/si";
// ---------------- Navbar ----------------
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const navbarHeight = 70;
      const y =
        element.getBoundingClientRect().top +
        window.scrollY -
        navbarHeight;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setMenuOpen(false);
  };

const links = [
  "Home",
  "About",
  "Skills",
  "Work",
  "Certifications",
  "Connect",
];

  return (
    <>
      <style>{`

        *{
          box-sizing:border-box;
        }

        html,body{
          margin:0;
          padding:0;
          overflow-x:hidden;
          width:100%;
        }

        a.nav-link:hover {
          text-shadow: 0 0 10px rgba(0, 224, 255, 0.7);
          transform: scale(1.08);
        }

        .hamburger{
          display:none;
          font-size:24px;
          cursor:pointer;
        }

        /* ===== MOBILE ===== */

        @media (max-width:768px){

          .hamburger{
            display:block;
            right:20px !important;
          }

          .logo{
            left:20px !important;
            font-size:16px !important;
          }

          .logo span{
            display:none;
          }

          .nav-links{
            position:fixed;
            top:70px;
            left:0;
            width:100%;
            background:rgba(20,20,20,0.95);
            backdrop-filter:blur(10px);
            flex-direction:column;
            gap:25px;
            padding:2rem 0;
            align-items:center;
            opacity:0;
            pointer-events:none;
            transform:translateY(-20px);
            transition:all 0.3s ease;
            z-index:999;
          }

          .nav-links.open{
            opacity:1;
            pointer-events:auto;
            transform:translateY(0);
          }

        }

      `}</style>

      <nav
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "14px 5%",
          background: "rgba(20,20,20,0.6)",
          backdropFilter: "blur(10px)",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          color: "#f5f5f5",
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 1000,
          fontFamily: "'Poppins', sans-serif",
        }}
      >

        {/* Logo */}

        <div
          className="logo"
          style={{
            position: "absolute",
            left: "5%",
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            fontSize: "20px",
            gap: "10px",
            cursor: "pointer",
          }}
          onClick={() => handleScroll("home")}
        >
          <img
            src={profilePic}
            alt="Profile"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "2px solid #d4af37",
              objectFit: "cover",
            }}
          />

          <span>Ashwinn B Menon</span>
        </div>

        {/* Links */}

        <div
          className={`nav-links ${menuOpen ? "open" : ""}`}
          style={{
            display: "flex",
            gap: "40px",
            alignItems: "center",
          }}
        >
          {links.map((section) => (
            <a
              key={section}
              className="nav-link"
              style={{
                textDecoration: "none",
                fontWeight: 500,
                fontSize: "16px",
                letterSpacing: "0.3px",
                cursor: "pointer",
                background: "linear-gradient(90deg,#f5f5f5,#e0e0e0)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                transition: "transform 0.3s ease, text-shadow 0.3s ease",
                display: "inline-block",
              }}
              onClick={() =>
                handleScroll(section.toLowerCase())
              }
            >
              {section}
            </a>
          ))}
        </div>

        {/* Hamburger */}

        <div
          className="hamburger"
          style={{ position: "absolute", right: "5%" }}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

      </nav>
    </>
  );
};



// ---------------- PROJECT CARD ----------------
function Project({ id, title, description, tools, image, demo }) {
  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.08)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderRadius: "20px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
        padding: "1.8rem",
        width: "300px",
        color: "#f0f0f0",
        textAlign: "center",
        transition: "all 0.4s ease",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-8px)";
        e.currentTarget.style.boxShadow =
          "0 15px 35px rgba(160,102,255,0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "0 10px 30px rgba(0,0,0,0.4)";
      }}
    >
      {/* Glass Light Glow */}
      <div
        style={{
          position: "absolute",
          top: "-40%",
          left: "-30%",
          width: "160%",
          height: "200%",
          background:
            "radial-gradient(circle at top left, rgba(160,102,255,0.25), transparent 60%)",
          pointerEvents: "none",
        }}
      />

      {/* Image */}
      {image && (
        <div
          style={{
            borderRadius: "14px",
            overflow: "hidden",
            marginBottom: "1rem",
            boxShadow: "0 0 15px rgba(255,255,255,0.05)",
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              width: "100%",
              height: "160px",
              objectFit: "cover",
              transition: "transform 0.4s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.transform = "scale(1)")
            }
          />
        </div>
      )}

      {/* Title */}
      <h3
        style={{
          fontSize: "1.3rem",
          background: "linear-gradient(90deg, #b28bff, #7b6cf6)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "0.6rem",
          fontWeight: "700",
          letterSpacing: "0.5px",
        }}
      >
        {title}
      </h3>

      {/* Description */}
      <p
        style={{
          fontSize: "0.92rem",
          color: "rgba(240,240,240,0.85)",
          marginBottom: "1.2rem",
          lineHeight: "1.5rem",
          minHeight: "55px",
        }}
      >
        {description}
      </p>

      {/* Tools */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginBottom: "1rem",
        }}
      >
        {tools.map((tool, i) => (
          <span
            key={i}
            style={{
              background: "rgba(255,255,255,0.1)",
              border: "1px solid rgba(255,255,255,0.25)",
              color: "#e6dcff",
              padding: "0.4rem 0.7rem",
              borderRadius: "10px",
              fontSize: "0.8rem",
              margin: "0.25rem",
              fontWeight: "500",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(160,102,255,0.25)";
              e.currentTarget.style.borderColor = "rgba(160,102,255,0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)";
            }}
          >
            {tool}
          </span>
        ))}
      </div>

      {/* Demo Button */}
      {demo && (
        <a
          href={demo}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            color: "#fff",
            fontSize: "0.9rem",
            textDecoration: "none",
            border: "none",
            borderRadius: "8px",
            padding: "0.5rem 1.2rem",
            background:
              "linear-gradient(90deg, #7b6cf6, #a066ff, #d178ff)",
            backgroundSize: "200% 200%",
            transition: "all 0.4s ease",
            fontWeight: "600",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundPosition = "right center";
            e.currentTarget.style.boxShadow =
              "0 0 15px rgba(160,102,255,0.6)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundPosition = "left center";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          🔗 View Demo
        </a>
      )}
    </div>
  );
}



// ---------------- PROJECT DETAILS ----------------
function ProjectDetails({ projects }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projects.find((p) => p.id.toString() === id);

  if (!project)
    return (
      <h2 style={{ textAlign: "center", marginTop: "5rem", color: "#fff" }}>
        Project not found!
      </h2>
    );

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "3rem auto",
        background: "#0f2027",
        padding: "2rem",
        borderRadius: "20px",
        color: "#fff",
        textAlign: "center",
      }}
    >
      <button
        style={{
          float: "right",
          background: "#ff4d4d",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          color: "#fff",
          fontSize: "1.2rem",
        }}
        onClick={() => navigate("/")}
      >
        ✕
      </button>

      <h2 style={{ marginBottom: "1rem", color: "#00fff9" }}>{project.title}</h2>
      <p style={{ marginBottom: "1rem", color: "#b0e8ff" }}>{project.description}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "0.5rem",
          flexWrap: "wrap",
        }}
      >
        {project.tools.map((tool, i) => (
          <span
            key={i}
            style={{
              background: "rgba(0,191,255,0.2)",
              padding: "0.3rem 0.7rem",
              borderRadius: "12px",
              color: "#00fff9",
              fontWeight: "600",
            }}
          >
            {tool}
          </span>
        ))}
      </div>
    </div>
  );
}


{/* ----------- CONTACT ----------- */}
const ContactSection = () => {
  const phoneNumber = "918590186368";
  const displayPhone = "+91 8590186368";
  const email = "ashwinnbmenon58@gmail.com";

  return (
    <section
      id="connect"
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        padding: "80px 5%",
        background: "#020202",
        color: "#fff",
        fontFamily: "'Inter', sans-serif",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* BACKGROUND RADIANCE */}
      <div
        style={{
          position: "absolute",
          top: "10%",
          right: "-10%",
          width: "500px",
          height: "500px",
          background:
            "radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      <style>{`
        .glass-panel {
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(15px);
          -webkit-backdrop-filter: blur(15px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 24px;
          padding: 2.5rem;
          transition: 0.3s ease;
          box-sizing: border-box;
        }

        .glass-panel:hover {
          background: rgba(255, 255, 255, 0.05);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
        }

        .contact-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.02);
          border-radius: 12px;
          text-decoration: none;
          color: #888;
          transition: 0.3s;
          margin-bottom: 0.8rem;
        }

        .contact-link:hover {
          background: #fff;
          color: #000;
          transform: translateX(8px);
        }

        .social-pill {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #111;
          border-radius: 12px;
          color: #fff;
          font-size: 1.2rem;
          transition: 0.3s;
          border: 1px solid #222;
        }

        .social-pill:hover {
          background: #fff;
          color: #000;
          transform: translateY(-5px);
        }

        @media (max-width: 968px) {
          .contact-grid {
            grid-template-columns: 1fr !important;
            gap: 1.5rem !important;
          }

          .glass-panel {
            padding: 1.5rem;
          }
        }

        @media (max-width: 600px) {
          #connect {
            padding: 60px 20px !important;
          }

          .glass-panel {
            padding: 1.25rem !important;
          }
        }

        html {
          scroll-behavior: smooth;
        }
      `}</style>

      {/* MAIN CONTACT GRID */}
      <div
        className="contact-grid"
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1.2fr 0.8fr",
          gap: "2rem",
          zIndex: 2,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {/* LEFT SIDE: MAIN INFO */}
        <div
          className="glass-panel"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div>
            <span
              style={{
                color: "#ff1e1e",
                letterSpacing: "4px",
                fontWeight: 900,
                fontSize: "0.7rem",
              }}
            >
              CONTACT
            </span>

            <h2
              style={{
                fontSize: "clamp(1.8rem, 5vw, 2.8rem)",
                fontWeight: 900,
                marginTop: "0.5rem",
                lineHeight: 1.2,
                marginBottom: 0,
              }}
            >
              Let’s build the
              <br />
              <span style={{ color: "#fb7575" }}>
                Future of Security.
              </span>
            </h2>
          </div>

          {/* INFORMATION */}
          <div
            style={{
              display: "grid",
              gap: "0.5rem",
              marginTop: "2rem",
            }}
          >
            <InfoStrip
              icon={<FaMapMarkerAlt />}
              label="Location"
              val="Kaitharam, Ernakulam, Kerala"
            />

            <InfoStrip
              icon={<FaPhoneAlt />}
              label="Secure Line"
              val={displayPhone}
            />

            <InfoStrip
              icon={<FaClock />}
              label="Availability"
              val="Mon – Fri | 9AM – 5PM"
            />
          </div>

          {/* MAP */}
          <div
            style={{
              marginTop: "2rem",
              height: "180px",
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid #222",
            }}
          >
            <iframe
              title="Kaitharam Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15709.43445851415!2d76.22384955!3d10.1516942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0810444586413d%3A0xc0289a42531a879e!2sKaitharam%2C%20Kerala!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{
                border: 0,
                filter:
                  "invert(90%) hue-rotate(180deg) contrast(1.5)",
              }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        {/* RIGHT SIDE: SOCIALS & DIRECT LINKS */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.5rem",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
              maxWidth: "500px",
              margin: "0 auto",
              boxSizing: "border-box",
            }}
          >
            {/* 1. LINKEDIN */}
            <a
              href="https://linkedin.com/in/ashwinn-b-menon/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "14px 18px",
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.04)",
                borderRadius: "14px",
                textDecoration: "none",
                boxSizing: "border-box",
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  fontSize: "0.9rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(0, 119, 181, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <FaLinkedin color="#0077B5" size={14} />
                </div>

                LinkedIn
              </span>

              <FaChevronRight
                size={10}
                color="rgba(255, 255, 255, 0.3)"
                style={{ flexShrink: 0 }}
              />
            </a>

            {/* 2. GITHUB */}
            <a
              href="https://github.com/Ashwinnbmenon"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "14px 18px",
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.04)",
                borderRadius: "14px",
                textDecoration: "none",
                boxSizing: "border-box",
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  fontSize: "0.9rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(255, 255, 255, 0.05)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <FaGithub color="#ffffff" size={14} />
                </div>

                GitHub
              </span>

              <FaChevronRight
                size={10}
                color="rgba(255, 255, 255, 0.3)"
                style={{ flexShrink: 0 }}
              />
            </a>

            {/* 3. EMAIL */}
            <a
              href={`mailto:${email}`}
              className="contact-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "14px 18px",
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.04)",
                borderRadius: "14px",
                textDecoration: "none",
                boxSizing: "border-box",
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  fontSize: "0.9rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(255, 30, 30, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <FaEnvelope color="#ff1e1e" size={14} />
                </div>

                Email Me
              </span>

              <FaChevronRight
                size={10}
                color="rgba(255, 255, 255, 0.3)"
                style={{ flexShrink: 0 }}
              />
            </a>

            {/* 4. WHATSAPP */}
            <a
              href={`https://wa.me/${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "14px 18px",
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.04)",
                borderRadius: "14px",
                textDecoration: "none",
                boxSizing: "border-box",
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  fontSize: "0.9rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(37, 211, 102, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <FaWhatsapp color="#25D366" size={16} />
                </div>

                WhatsApp
              </span>

              <FaChevronRight
                size={10}
                color="rgba(255, 255, 255, 0.3)"
                style={{ flexShrink: 0 }}
              />
            </a>

            {/* 5. INSTAGRAM */}
            <a
              href="https://www.instagram.com/ashwii.nn._/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                padding: "14px 18px",
                background: "rgba(255, 255, 255, 0.03)",
                border: "1px solid rgba(255, 255, 255, 0.04)",
                borderRadius: "14px",
                textDecoration: "none",
                boxSizing: "border-box",
                transition: "all 0.3s ease",
              }}
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  fontSize: "0.9rem",
                  color: "#fff",
                  fontWeight: 600,
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "8px",
                    background: "rgba(228, 64, 95, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <FaInstagram color="#E4405F" size={14} />
                </div>

                Instagram
              </span>

              <FaChevronRight
                size={10}
                color="rgba(255, 255, 255, 0.3)"
                style={{ flexShrink: 0 }}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

/* ----------- INFO STRIP ----------- */
const InfoStrip = ({ icon, label, val }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "15px",
      padding: "8px 0",
    }}
  >
    <div
      style={{
        color: "#ff1e1e",
        fontSize: "1.1rem",
      }}
    >
      {icon}
    </div>

    <div>
      <div
        style={{
          fontSize: "0.55rem",
          color: "#444",
          fontWeight: 900,
          textTransform: "uppercase",
          letterSpacing: "1px",
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: "0.85rem",
          color: "#ccc",
        }}
      >
        {val}
      </div>
    </div>
  </div>
);

/* ----------- SOCIAL BUTTON ----------- */
const SocialBtn = ({ href, icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="social-pill"
  >
    {icon}
  </a>
);



// ---------------- Main App ----------------

function App() {

  
  const certificates = [
    "/certificates/c2.png",
    "/certificates/c1.png",
    "/certificates/c3.png",
    "/certificates/c10.png",
    "/certificates/c11.png",
    "/certificates/c5.png",
    "/certificates/c4.png",
    "/certificates/c9.png",
    "/certificates/c6.png",
    "/certificates/c7.png",
    "/certificates/c8.png",
  ];

  const certificatesNames = [
    "SSLC",
    "PLUS TWO - Computer Science",
    "DIPLOMA - Computer Engineering",
    "Cyber Security & Ethical Hacking",
    "Cyber Security internship",
    "Zoople Company",
    "National Level Tech Fest - RCSS Ernakulam",
    "Zoople Flutter Development",
    "Google Analytics",
    "Google Ads Display",
    "Google Ads Video",
  ];

  const educationIndexes = [0,1,2,3];
  const skillsIndexes = [4,5,6,7,8,9,10];

  const [group, setGroup] = useState(null);
  const [modalIndex, setModalIndex] = useState(0);
  const activeArray = group === "education" ? educationIndexes : skillsIndexes;
  
  const projects = [
    {
      id: 1,
      title: "Weather Monitoring Web Application",
      associatedWith: "Kuttukaran Polytechnic College",
      description:
        "An interactive and responsive web platform designed to deliver real-time weather insights for any city around the globe.",
      image: weathermimg,
      rating: 5,
      techStack: [
        "React.js",
        "OpenWeatherMap API",
        "HTML",
        "CSS",
        "JavaScript",
      ],
      features: [
        "Live Weather Search – Fetch weather instantly by city name.",
        "Dynamic UI – Background and icons update based on weather conditions.",
        "Comprehensive Data – Temperature, humidity, pressure, wind speed.",
        "Responsive Design – Works on mobile, tablet and desktop.",
        "Real-Time API Integration – Accurate and up-to-date data.",
      ],
      objective:
        "To build a clean, modern weather dashboard demonstrating strong API integration, state management, and front-end development skills.",
   
    },
{
  id: 5,
  title: "ATM Banking System",
  associatedWith: "Zoople Technologies Kochi",

  description:
    "A console-based ATM banking system developed in Python that allows users to securely access their bank account, check balances, deposit and withdraw money, and manage account transactions through an interactive menu.",

  image: atmimg,
  rating: 5,

  techStack: [
    "Python",
    "Object-Oriented Programming (OOP)",
    "Google Colab",
    "Jupyter Notebook",
    "Console Application",
  ],

  features: [
    "PIN Authentication – Securely verifies the user's PIN before granting account access.",
    "Balance Management – Allows users to view the current account balance.",
    "Deposit Money – Enables users to deposit valid amounts into their account.",
    "Withdraw Money – Supports withdrawals while preventing insufficient-balance transactions.",
    "Input Validation – Handles invalid amounts and menu choices.",
    "Interactive ATM Menu – Provides a simple console-based interface for banking operations.",
    "Object-Oriented Design – Uses a BankAccount class to manage account data and operations.",
  ],

  objective:
    "To develop a simple and interactive ATM banking system that demonstrates Python fundamentals, object-oriented programming, user input handling, authentication, and basic financial transaction management.",

  githubLink:
    "https://github.com/Ashwinnbmenon/ATM-Python-project",
},
    {
      id: 2,
      title: "Full-Stack E-Commerce Platform",
      associatedWith: "Kuttukaran Polytechnic College",
      description:
        "A scalable and modern online shopping platform with secure authentication, product management and seamless checkout experience.",
      image: foodwebimg,
      rating: 3,
      techStack: [
        "React.js",
        "Node.js",
        "Express.js",
        "MongoDB",
        "JWT Authentication",
      ],
      features: [
        "User Authentication & Authorization",
        "Product Management Dashboard",
        "Shopping Cart & Order Tracking",
        "Secure Checkout Flow",
        "Admin Panel for Inventory Control",
      ],
      objective:
        "To develop a complete full-stack commerce solution showcasing backend API design, database management, and secure authentication handling.",
    
    },
  ];
  
 
  const sectionStyle = (bg = '#bebabaff') => ({
    padding: '6rem 1rem 3rem',
    backgroundColor: bg,
    textAlign: 'center'
  });
const testimonials = [
  {
    name: "Sreejesh R",
 project: "Weather Monitoring Web App, TEAM MATE",
    semester: "Semester 6",
    review:
      "Working together on the weather monitoring project was a great experience. The UI design was clean, and API integration worked smoothly, showing strong collaboration and attention to detail.",

    hiText: "Hi Sreekesh 👋",
    hiTime: "10:44 PM",
    time: "10:45 PM",
  },
  {
    name: "Avani Krishna",
    project: "Weather Monitoring Web App, TEAM MATE",
    semester: "Semester 6",
    review:
      "The project was well structured with organized React components. It was great collaborating to build a responsive interface that provides accurate real-time weather data.",
    hiText: "Hi Avani 👋",
    hiTime: "9:10 PM",
    time: "9:12 PM",
  },
  {
    name: "Ebin P",
   project: "Weather Monitoring Web App, Faculty",
    semester: "Semester 6",
    review:
      "The weather monitoring application demonstrates a good understanding of API integration, responsive UI design, and modern web development practices, showing solid technical skills and dedication.",
    hiText: "Hi Ebin sir ",
    hiTime: "8:20 PM",
    time: "8:25 PM",
  },
  {
    name: "Joyal Saju",
    project: "E-Commerce Platform, TEAM MATE",
    semester: "Semester 4",
    review:
      "Collaborating on the full-stack e-commerce project was a great experience. The user interface was intuitive and the backend integration handled product and user data efficiently.",
    hiText: "Hi Joyal 👋",
    hiTime: "6:10 PM",
    time: "6:12 PM",
  },
  {
    name: "Arjun S",
   project: "E-Commerce Platform, TEAM MATE",
    semester: "Semester 4",
    review:
      "The project showcased strong full-stack development skills, combining a responsive frontend with well-structured backend logic, demonstrating good planning and teamwork throughout development.",
    hiText: "Hi Arjun 👋",
    hiTime: "5:40 PM",
    time: "5:42 PM",
  },
 
  {
    name: "Sreekanth Sir",
   project: "Project Evaluation, Faculty",
    semester: "—",
    review:
      "The projects demonstrate strong understanding of modern web development concepts. The implementation, UI design, and teamwork reflect good technical skills, proper planning, and dedication throughout the development process.",
    hiText: "Hi Sreekanth Sir ",
    hiTime: "3:20 PM",
    time: "3:25 PM",
  },
   {
    name: "Asha Rajeev",
    project: "Full-Stack Project, HOD",
    semester: "Semester 4",
    review:
      "The full-stack project demonstrates a solid understanding of both frontend and backend development. The implementation shows structured development, technical knowledge, and effective teamwork.",
    hiText: "Hi Asha mam",
    hiTime: "4:15 PM",
    time: "4:18 PM",
  },
  {
    name: "Vishnupriya Mam",
    project: "Project Evaluation, Faculty",
    semester: "—",
    review:
      "Both projects show good creativity and technical knowledge. The structured approach, clean interface design, and effective teamwork highlight the ability to build practical and responsive web applications.",
    hiText: "Hi Vishnupriya Mam ",
    hiTime: "2:10 PM",
    time: "2:15 PM",
  },
];

  
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div style={{ fontFamily: 'Arial, sans-serif' }}>
              <Navbar />


{/* ----------- home section ---------- */}
<section id="home" style={{
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      background: '#050505',
      color: '#fff',
      fontFamily: "'Inter', sans-serif",
      textAlign: 'center',
      padding: '20px',
      overflow: 'hidden'
    }}>
      
      <style>{`
        @keyframes letterJoin {
          0% { letter-spacing: 0.8em; filter: blur(12px); opacity: 0; }
          100% { letter-spacing: -0.05em; filter: blur(0); opacity: 1; }
        }

        @keyframes rainbowFlow {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .hero-name {
          font-size: clamp(2.8rem, 14vw, 8rem); 
          font-weight: 900;
          line-height: 0.9;
          margin: 0;
          background: linear-gradient(
            90deg, 
            #ffffff, #00fff9, #ff00c1, #ffffff
          );
          background-size: 300% 300%;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: 
            letterJoin 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards,
            rainbowFlow 8s ease infinite;
        }

        .animate-sub { 
          animation: slideUp 0.8s ease 0.8s forwards; 
          opacity: 0; 
          display: flex;
          flex-direction: column;
          align-items: center; /* FIX: Fixed broken layout syntax "align_items" */
        }

        .btn-main {
          padding: 14px 32px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 0.85rem;
          text-decoration: none;
          transition: 0.3s;
          border: 1px solid rgba(255,255,255,0.1);
          display: inline-block;
        }

        .btn-white { background: #fff; color: #000; }
        .btn-outline { color: #fff; background: rgba(255, 255, 255, 0.03); backdrop-filter: blur(5px); }

        .btn-main:hover { 
          transform: translateY(-3px); 
          box-shadow: 0 10px 25px rgba(0, 255, 249, 0.2);
          border-color: #00fff9;
        }

        .social-link {
          transition: 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          display: flex;
          align-items: center;
          justifyContent: center;
        }
        
        .social-link.github { color: #fff; }
        .social-link.linkedin { color: #0077b5; }
        .social-link.tryhackme { color: #ff0000; }

        .social-link:hover { 
          transform: scale(1.2) rotate(5deg);
        }

        /* MOBILE SPECIFIC FIXES */
        @media (max-width: 600px) {
          .hero-name { line-height: 1; margin-bottom: 10px; }
          .btn-container { 
            flex-direction: column !important; 
            width: 100%; 
            max-width: 260px; 
            margin: 0 auto 30px auto !important;
            gap: 12px !important;
          }
          .btn-main { width: 100%; text-align: center; padding: 12px 0; }
          .social-group { gap: 30px !important; }
          
          /* FIX: Added relative positioning rules to keep the absolute labels from burying screen contents */
          .footer-label { font-size: 0.55rem !important; bottom: 15px !important; width: 90%; text-align: center; left: 50%; transform: translateX(-50%); }
        }
      `}</style>

      {/* 1. NAME SECTION */}
      <div style={{ zIndex: 2 }}>
        <h1 className="hero-name">
          ASHWINN<br/>B.MENON
        </h1>
      </div>

      {/* 2. DESCRIPTION */}
      <div className="animate-sub" style={{ zIndex: 2 }}>
        <p style={{ 
          color: '#9c9090', 
          fontSize: 'clamp(0.85rem, 4vw, 1.1rem)', 
          maxWidth: '400px', 
          lineHeight: '1.5', 
          marginTop: '15px',
          padding: '0 10px'
        }}>
          Computer Engineering Student. Focusing on <span style={{ color: '#ee1212', fontWeight: 'bold' }}>Cybersecurity [ EH ] & Data Science, AI, ML .</span> 
        </p>
      </div>

      {/* 3. ACTIONS & ICONS */}
      {/* FIX: Changed height handling from static offsets to auto layout blocks so content never drops out of bounds */}
      <div
  className="animate-sub"
  style={{
    marginTop: '30px',
    width: '100%',
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }}
>
  <div
    className="btn-container"
    style={{
      display: 'flex',
      gap: '15px',
      justifyContent: 'center',
      marginBottom: '40px'
    }}
  >
    <a
      href={resume}
      download="resume.pdf"
      className="btn-main btn-white"
    >
      DOWNLOAD ATS CV
    </a>
  </div>
</div>

      {/* 4. FOOTER LABEL */}
      <div className="footer-label" style={{ 
        position: 'absolute', bottom: '30px', left: '50%', transform: 'translateX(-50%)',
        fontSize: '0.7rem', color: '#666', letterSpacing: '2px', fontWeight: 900, width: '100%'
      }}>
        <span style={{ color: '#f60a0a' }}>●</span> EST 2024 // KERALA INDIA // VIEWS 37+
      </div>
    </section>


{/* ----------- ABOUT SECTION ---------- */}
<section
  id="about"
  style={{
    minHeight: "100vh",
    width: "100%",
    padding: "clamp(4rem, 10vw, 8rem) 5%",
    boxSizing: "border-box",
    background: "#050505",
    color: "#eee",
    fontFamily: "'Inter', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollMarginTop: "80px",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* Standardized Header */}
  <div
    style={{
      width: "100%",
      maxWidth: "1100px",
      marginBottom: "5rem",
      position: "relative",
      zIndex: 1,
    }}
  >
    <span
      style={{
        color: "#7f5cff",
        textTransform: "uppercase",
        fontSize: "0.85rem",
        fontWeight: 600,
        letterSpacing: "4px",
        display: "block",
        marginBottom: "10px",
      }}
    />

    <h2
      style={{
        fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
        fontWeight: 900,
        margin: 0,
        background:
          "linear-gradient(135deg, #6a11cb, #7f5cff, #ff4d9d, #00c6ff, #00fff9)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      Career Snapshot
    </h2>

    <div
      style={{
        height: "1px",
        width: "100%",
        background:
          "linear-gradient(90deg, rgba(225, 224, 228, 0.5), transparent)",
        marginTop: "20px",
      }}
    />
  </div>

  {/* THE DATA GRID */}
  <div
    style={{
      width: "100%",
      maxWidth: "1100px",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      zIndex: 1,
    }}
  >
    {/* Grid Header */}
    <div
      className="desktop-header"
      style={{
        display: "grid",
        gridTemplateColumns: "160px 140px 1fr 140px",
        paddingBottom: "1.2rem",
        borderBottom: "1px solid #1a1a1a",
        fontSize: "0.9rem",
        color: "#878585",
        fontWeight: 600,
      }}
    >
      <div>Timeline</div>
      <div>Entity</div>
      <div>Institution & Qualification</div>
      <div style={{ textAlign: "right" }}>Classification</div>
    </div>

    {[
      {
        year: "2011 — 2020",
        title: "Schooling Foundation",
        inst: "Kendriya Vidyalaya NAD Kalamassery",
        tag: "ROOT",
        img: "/certificates/kv.png",
        desc:
          "Foundational primary and secondary education with a focus on disciplined learning.",
        color: "#60a5fa",
      },
      {
        year: "2020 — 2021",
        title: "SSLC (96%)",
        inst: "Govt. HSS Kaitharam North Paravur",
        tag: "ACADEMIC",
        img: "/certificates/sslc.png",
        desc:
          "Highest distinction achieved with core focus on Sciences and Mathematics.",
        color: "#22c55e",
      },
      {
        year: "2021 — 2023",
        title: "+2 Computer Science",
        inst: "Model Technical HSS (IHRD) Kaprassery Aluva",
        tag: "STARTED TECH",
        img: "/certificates/plustwo.png",
        desc:
          "Technical higher secondary education specializing in computer science fundamentals.",
        color: "#eab308",
      },
      {
        year: "2023 — 2025",
        title: "Diploma in Computer Engineering",
        inst: "Kuttukaran Polytechnic College Aluva",
        tag: "ENGINEERING",
        img: "/certificates/kptc.png",
        desc:
          "Three-year engineering program covering hardware, systems, and networking.",
        color: "#f97316",
      },
      {
        year: "2024 (Intern)",
        title: "Flutter Development Specialist",
        inst: "Zoople Technologies, Kochi",
        tag: "INDUSTRY",
        img: "/certificates/zoople.png",
        desc:
          "Practical application of development workflows and mobile application logic.",
        color: "#ec4899",
      },
      {
        year: "2025 — 2026",
        title: "Cybersecurity & Ethical Hacking",
        inst: "CC Cyber Campus, Kochi",
        tag: "SPECIALIST",
        img: "/certificates/cc.png",
        desc:
          "Advanced specialization in offensive security and vulnerability assessment.",
        color: "#ef4444",
      },
      {
        year: "2026 — Present",
        title: "Data Science, AI, ML & Gen AI",
        inst: "Zoople Technologies, Kochi",
        tag: "SPECIALIST",
        img: "/certificates/zoople.png",
        desc:
          "Practical experience in Data Science, AI, Machine Learning, and Generative AI, focusing on data analysis, intelligent solutions, and automation.",
        color: "#ec4455",
      },
      {
        year: "Present",
        title: "Web & Cybersecurity Freelancer",
        inst: "Independent Operations",
        tag: "LIVE",
        img: "/certificates/free.png",
        desc:
          "Providing secure digital solutions and security consulting for private clients.",
        color: "#a855f7",
      },
    ].map((item, i) => (
      <div
        key={`${item.year}-${item.title}-${i}`}
        className="snapshot-row"
        style={{
          borderBottom: "1px solid #111",
          position: "relative",
          overflow: "hidden",
          transition: "background 0.2s ease",
        }}
      >
        <div className="grid-container">
          {/* Timeline */}
          <div
            className="item-year"
            style={{
              color: "#555",
              fontWeight: 500,
              fontFamily: "monospace",
            }}
          >
            {item.year}
          </div>

          {/* Complete 4-Face Image Cube */}
          <div className="item-logo">
            <div className="cube-scene">
              <div className="cube-object">
                <div className="cube-face face-front">
                  <img src={item.img} alt={`${item.inst} logo`} />
                </div>

                <div className="cube-face face-right">
                  <img src={item.img} alt={`${item.inst} logo`} />
                </div>

                <div className="cube-face face-back">
                  <img src={item.img} alt={`${item.inst} logo`} />
                </div>

                <div className="cube-face face-left">
                  <img src={item.img} alt={`${item.inst} logo`} />
                </div>
              </div>
            </div>
          </div>

          {/* Details */}
          <div
            className="item-details"
            style={{
              paddingLeft: "20px",
            }}
          >
            <div
              style={{
                fontSize: "1.2rem",
                fontWeight: 800,
                color: "#fff",
                marginBottom: "4px",
              }}
            >
              {item.inst}
            </div>

            <div
              style={{
                color: "#706d6d",
                fontSize: "1rem",
                fontWeight: 600,
                marginBottom: "8px",
              }}
            >
              {item.title}
            </div>

            <div
              style={{
                color: "#726e6e",
                fontSize: "0.95rem",
                lineHeight: "1.6",
              }}
            >
              {item.desc}
            </div>
          </div>

          {/* Classification */}
          <div className="item-tag">
            <span
              style={{
                fontSize: "0.7rem",
                padding: "5px 12px",
                border: `1px solid ${item.color}44`,
                borderRadius: "4px",
                color: item.color,
                letterSpacing: "1px",
                fontWeight: 800,
                background: `${item.color}08`,
                textTransform: "uppercase",
              }}
            >
              {item.tag}
            </span>
          </div>
        </div>
      </div>
    ))}
  </div>

  <style>{`
    .cube-scene {
      width: 100px;
      height: 100px;
      perspective: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cube-object {
      width: 80px;
      height: 80px;
      position: relative;
      transform-style: preserve-3d;
      transform: rotateX(-10deg) rotateY(0deg);
      animation: genuineCubeSpinLeft 10s linear infinite;
    }

    .cube-face {
      position: absolute;
      width: 80px;
      height: 80px;
      background: #0a0a0a;
      border: 1px solid rgba(255, 255, 255, 0.08);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      backface-visibility: visible;
      box-sizing: border-box;
    }

    .cube-face img {
      width: 80%;
      height: 80%;
      object-fit: contain;
      filter: brightness(1.1);
    }

    .face-front {
      transform: rotateY(0deg) translateZ(40px);
    }

    .face-right {
      transform: rotateY(90deg) translateZ(40px);
    }

    .face-back {
      transform: rotateY(180deg) translateZ(40px);
    }

    .face-left {
      transform: rotateY(-90deg) translateZ(40px);
    }

    @keyframes genuineCubeSpinLeft {
      0% {
        transform: rotateX(-10deg) rotateY(0deg);
      }

      100% {
        transform: rotateX(-10deg) rotateY(-360deg);
      }
    }

    .snapshot-row:hover .cube-object {
      animation-duration: 20s;
    }

    .snapshot-row:hover .cube-face {
      border-color: rgba(255, 255, 255, 0.15);
      background: #0f0f0f;
    }

    .snapshot-row:hover {
      background: rgba(255, 255, 255, 0.01);
    }

    .grid-container {
      display: grid;
      grid-template-columns: 160px 140px 1fr 140px;
      align-items: center;
      padding: 3rem 0;
    }

    .item-year {
      font-size: 1rem;
    }

    .item-tag {
      display: flex;
      justify-content: flex-end;
    }

    @media (max-width: 900px) {
      .desktop-header {
        display: none !important;
      }

      .grid-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 2.5rem 0;
        gap: 1.5rem;
      }

      .item-year {
        font-size: 0.85rem;
        order: 1;
        width: 100%;
        border-bottom: 1px solid #1a1a1a;
        padding-bottom: 0.5rem;
      }

      .item-logo {
        order: 2;
        width: 100%;
        display: flex;
        justify-content: flex-start;
      }

      .cube-scene {
        width: 120px !important;
        height: 120px !important;
      }

      .cube-object,
      .cube-face {
        width: 100px !important;
        height: 100px !important;
      }

      .face-front {
        transform: rotateY(0deg) translateZ(50px) !important;
      }

      .face-right {
        transform: rotateY(90deg) translateZ(50px) !important;
      }

      .face-back {
        transform: rotateY(180deg) translateZ(50px) !important;
      }

      .face-left {
        transform: rotateY(-90deg) translateZ(50px) !important;
      }

      .item-details {
        order: 3;
        padding: 0 !important;
      }

      .item-tag {
        order: 0;
        width: 100%;
        justify-content: flex-start;
        margin-bottom: -0.5rem;
      }
    }
  `}</style>
</section>

{/*------------ SKILLS -----------*/}
<section
  id="skills"
  style={{
    background:
      "radial-gradient(circle at 50% 50%, #0a0a12 0%, #000000 100%)",
    width: "100%",
    minHeight: "150vh",

    // ↓ Less space above the Skills section
    padding: "5rem 0 10rem",

    fontFamily: "'Inter', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
  }}
>
  <style>{`
    @keyframes rotatePath {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes counterRotate {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(-360deg);
      }
    }

    @keyframes float {
      0%,
      100% {
        transform: translateY(0px);
      }

      50% {
        transform: translateY(-10px);
      }
    }

    .neural-engine {
      display: flex !important;
    }

    .mobile-toolkit {
      display: none !important;
    }

    @media (max-width: 768px) {
      .neural-engine {
        display: none !important;
      }

      .mobile-toolkit {
        display: grid !important;
      }
    }
  `}</style>

  {/* Hyper-Space Background Elements */}
  <div
    style={{
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundImage:
        "radial-gradient(rgba(127, 92, 255, 0.05) 1px, transparent 1px)",
      backgroundSize: "50px 50px",
      opacity: 0.3,
      pointerEvents: "none",
    }}
  />

  {/* Header Section */}
  <div
    style={{
      zIndex: 10,
      marginBottom: "2rem",
      textAlign: "center",
    }}
  >
    <h2
      style={{
        fontSize: "clamp(3rem, 8vw, 4.5rem)",
        fontWeight: 900,
        letterSpacing: "-3px",
        margin: 0,
        background: `
          linear-gradient(
            135deg,
            #6a11cb,
            #7f5cff,
            #ff4d9d,
            #00c6ff,
            #00fff9
          )
        `,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        filter:
          "drop-shadow(0 10px 20px rgba(127, 92, 255, 0.2))",
      }}
    >
      TOOLK!T
    </h2>

    <div
      style={{
        height: "2px",
        width: "60px",
        background: "#7f5cff",
        margin: "1rem auto",
      }}
    />
  </div>

  {/* MAIN ORBITAL ENGINE (1st ONE) */}
  <div
    className="neural-engine"
    style={{
      position: "relative",
      width: "900px",
      height: "900px",
      alignItems: "center",
      justifyContent: "center",
      perspective: "1200px",
    }}
  >
    {/* ===== PREMIUM RADAR GRAPH BACKGROUND ===== */}
    <svg
      viewBox="0 0 400 400"
      style={{
        position: "absolute",
        width: "600px",
        height: "600px",
        zIndex: 1,
        opacity: 0.5,
        filter:
          "drop-shadow(0 0 20px rgba(127, 92, 255, 0.2))",
      }}
    >
      {/* Web-style Radar Grid */}
      {[0.2, 0.4, 0.6, 0.8, 1].map((p, i) => (
        <circle
          key={i}
          cx="200"
          cy="200"
          r={150 * p}
          fill="none"
          stroke="rgba(127, 92, 255, 0.2)"
          strokeWidth="1"
        />
      ))}

      {/* Dynamic Skill Shape */}
      <polygon
        points="200,80 280,120 320,200 280,280 200,320 120,280 80,200 120,120"
        fill="rgba(127, 92, 255, 0.15)"
        stroke="#7f5cff"
        strokeWidth="2"
        className="radar-shape"
      />
    </svg>

    {/* Animated Orbit Rings */}
    {[640, 642].map((size, i) => (
      <div
        key={i}
        style={{
          position: "absolute",
          width: `${size}px`,
          height: `${size}px`,
          border: "1px solid rgba(127, 92, 255, 0.1)",
          borderRadius: "50%",
          boxShadow:
            i === 0
              ? "inset 0 0 50px rgba(127, 92, 255, 0.05)"
              : "none",
          pointerEvents: "none",
        }}
      />
    ))}

    {/* THE HUB (THE "CORE") */}
    <div
      className="core-hub"
      style={{
        position: "relative",
        zIndex: 50,
        width: "180px",
        height: "180px",
        background: "rgba(2, 2, 5, 0.8)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid rgba(127, 92, 255, 0.6)",
        boxShadow:
          "0 0 120px rgba(127, 92, 255, 0.4), inset 0 0 30px rgba(127, 92, 255, 0.2)",
        backdropFilter: "blur(30px)",
      }}
    >
      <div
        className="core-inner"
        style={{
          fontSize: "5.5rem",
          filter:
            "drop-shadow(0 0 20px rgba(127, 92, 255, 0.8))",
          animation: "float 4s ease-in-out infinite",
        }}
      >
        🧠
      </div>

      <div className="pulse-ring" />
    </div>

    {/* 8-NODE SYSTEM */}
{[
    {
    name: "Cyber Security",
    icon: "🛡️",
    color: "#ff2e2e",
    delay: "0s",
    tools: ["Kali Linux", "Nmap", "Wireshark"],
  },
  {
    name: "Web Development",
    icon: "🌐",
    color: "#00d2ff",
    delay: "-3.75s",
    tools: ["HTML5", "React", "Next.js"],
  },
  {
    name: "Cloud & DevOps",
    icon: "☁️",
    color: "#00ff87",
    delay: "-7.5s",
    tools: ["AWS", "GitHub Actions"],
  },
  {
    name: "Penetration Testing",
    icon: "🔐",
    color: "#ff4d9d",
    delay: "-11.25s",
    tools: ["Burp Suite", "Metasploit", "Nmap"],
  },
  {
    name: "AI / ML",
    icon: "🤖",
    color: "#bd00ff",
    delay: "-15s",
    tools: ["PyTorch", "Scikit-learn", "XGBoost"],
  },
  {
    name: "App Development",
    icon: "📱",
    color: "#ff0055",
    delay: "-18.75s",
    tools: ["Flutter", "Dart", "Firebase"],
  },
  {
    name: "Data Science",
    icon: "📊",
    color: "#00bfa5",
    delay: "-22.5s",
    tools: ["Pandas", "NumPy", "Matplotlib"],
  },
  {
    name: "Generative AI",
    icon: "✨",
    color: "#00ffa3",
    delay: "-26.25s",
    tools: ["OpenAI API", "LangChain"],
  },
    ].map((node, i) => (
      <div
        key={i}
        className="node-wrapper"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          animation: "rotatePath 30s linear infinite",
          animationDelay: node.delay,
          willChange: "transform",
        }}
      >
        <div
          className="node-anchor"
          style={{
            position: "absolute",
            left: "calc(50% + 340px)",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          {/* Dynamic Laser Line */}
          <div
            className="node-laser"
            style={{
              position: "absolute",
              right: "100%",
              top: "50%",
              width: "250px",
              height: "2px",
              background: `linear-gradient(
                90deg,
                transparent,
                ${node.color}50,
                ${node.color}
              )`,
              opacity: 0.35,
              filter: "blur(1px)",
            }}
          />

          {/* GLASS CARD */}
          <div
            className="node-card"
            style={{
              width: "250px",
              padding: "1.5rem",
              background: "rgba(255, 255, 255, 0.01)",
              backdropFilter: "blur(20px)",
              borderRadius: "24px",
              border: "1px solid rgba(255, 255, 255, 0.08)",
              borderLeft: `6px solid ${node.color}`,
              boxShadow: `0 10px 40px -10px rgba(0,0,0,0.5), 0 0 20px ${node.color}10`,
              animation: "counterRotate 30s linear infinite",
              animationDelay: node.delay,
              transition:
                "all 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
              willChange: "transform",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "14px",
                  background: `${node.color}20`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: `inset 0 0 10px ${node.color}30`,
                }}
              >
                <span style={{ fontSize: "1.5rem" }}>
                  {node.icon}
                </span>
              </div>

              <div>
                <h3
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 800,
                    color: "#fff",
                    margin: 0,
                    letterSpacing: "0.5px",
                  }}
                >
                  {node.name}
                </h3>

                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    marginTop: "4px",
                  }}
                >
                  {node.tools.map((t, idx) => (
                    <span
                      key={idx}
                      style={{
                        fontSize: "0.65rem",
                        color: "#999",
                        fontWeight: 600,
                      }}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* MOBILE TOOLKIT (2nd ONE) */}
  <div
    className="mobile-toolkit"
    style={{
      width: "100%",
      maxWidth: "420px",
      gap: "14px",
      padding: "20px",
      zIndex: 10,
      boxSizing: "border-box",
    }}
  >
    {[
      {
        name: "Cyber Security",
        icon: "🛡️",
        color: "#ff2e2e",
        tools: ["Nmap", "BurpSuite", "Kali"],
      },
      {
        name: "Web Dev",
        icon: "🌐",
        color: "#00d2ff",
        tools: ["React", "Next.js", "HTML"],
      },
    
      {
        name: "Data Science, Gen AI",
        icon: "🤖",
        color: "#bd00ff",
        tools: ["Python", "PyTorch", "TensorFlow"],
      },
      {
        name: "AI / ML",
        icon: "🤖",
        color: "#bd00ff",
        tools: ["PyTorch", "TensorFlow"],
      },
      {
        name: "App Design",
        icon: "📱",
        color: "#ff0055",
        tools: ["Flutter", "Firebase"],
      },
    
      {
        name: "Generative AI",
        icon: "✨",
        color: "#00ffa3",
        tools: ["OpenAI API", "Hugging Face", "ComfyUI"],
      },
    ].map((node, i) => (
      <div
        key={i}
        style={{
          background: "rgba(255,255,255,0.02)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderRadius: "22px",
          padding: "18px",
          border: "1px solid rgba(255,255,255,0.08)",
          borderLeft: `5px solid ${node.color}`,
          boxShadow: `0 10px 30px -10px rgba(0,0,0,0.7), 0 0 20px ${node.color}10`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "52px",
              height: "52px",
              borderRadius: "14px",
              background: `${node.color}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.5rem",
              flexShrink: 0,
            }}
          >
            {node.icon}
          </div>

          <div style={{ flex: 1 }}>
            <h3
              style={{
                color: "#fff",
                margin: 0,
                fontSize: "1.05rem",
                fontWeight: 800,
                letterSpacing: "0.3px",
              }}
            >
              {node.name}
            </h3>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "6px",
                marginTop: "8px",
              }}
            >
              {node.tools.map((tool, idx) => (
                <span
                  key={idx}
                  style={{
                    padding: "4px 10px",
                    borderRadius: "999px",
                    background: "rgba(255,255,255,0.05)",
                    color: "#b3b3b3",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    border: "1px solid rgba(255,255,255,0.03)",
                  }}
                >
                  {tool}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>

  {/* FOOTER TECH TRAIN (Seamless) */}
  <div
    style={{
      width: "100%",
      marginTop: "4rem",
      zIndex: 5,
    }}
  >
    <div className="train-viewport">
      <div className="train-scroll">
        {[
          "Nmap",
          "Docker",
          "React",
          "Rust",
          "AWS",
          "Figma",
          "Python",
          "K8s",
          "Next.js",
          "Postgres",
        ].map((t, i) => (
          <div key={i} className="train-item">
            <img
              src={`https://cdn.simpleicons.org/${t
                .toLowerCase()
                .replace(".js", "dotjs")}/7f5cff`}
              alt={t}
              style={{ width: "30px" }}
            />
            <span>{t}</span>
          </div>
        ))}

        {/* Duplicate for loop */}
        {[
          "Nmap",
          "Docker",
          "React",
          "Rust",
          "AWS",
          "Figma",
          "Python",
          "K8s",
          "Next.js",
          "Postgres",
        ].map((t, i) => (
          <div key={`d-${i}`} className="train-item">
            <img
              src={`https://cdn.simpleicons.org/${t
                .toLowerCase()
                .replace(".js", "dotjs")}/7f5cff`}
              alt={t}
              style={{ width: "30px" }}
            />
            <span>{t}</span>
          </div>
        ))}
      </div>
    </div>
  </div>

  <style>
    {`
      @keyframes rotatePath {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }

      @keyframes counterRotate {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(-360deg);
        }
      }

      @keyframes float {
        0%,
        100% {
          transform: translateY(0);
        }

        50% {
          transform: translateY(-15px);
        }
      }

      @keyframes pulseRadar {
        0% {
          filter: drop-shadow(0 0 5px #7f5cff);
          opacity: 0.4;
        }

        50% {
          filter: drop-shadow(0 0 20px #7f5cff);
          opacity: 0.7;
        }

        100% {
          filter: drop-shadow(0 0 5px #7f5cff);
          opacity: 0.4;
        }
      }

      .radar-shape {
        animation: pulseRadar 3s infinite ease-in-out;
        transform-origin: center;
      }

      .pulse-ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid #7f5cff;
        animation: pulseCore 4s infinite
          cubic-bezier(0.215, 0.61, 0.355, 1);
      }

      @keyframes pulseCore {
        0% {
          transform: scale(1);
          opacity: 0.5;
        }

        100% {
          transform: scale(2.2);
          opacity: 0;
        }
      }

      .node-wrapper:hover {
        animation-play-state: paused;
        z-index: 100;
      }

      .node-wrapper:hover .node-card {
        transform: scale(1.15) translateZ(80px);
        background: rgba(255, 255, 255, 0.07);
        border-color: rgba(255, 255, 255, 0.3);
        box-shadow: 0 40px 80px rgba(0, 0, 0, 0.8);
      }

      .node-wrapper:hover .node-laser {
        opacity: 1;
        height: 3px;
        width: 300px;
      }

      .train-viewport {
        overflow: hidden;
        white-space: nowrap;
        mask-image: linear-gradient(
          to right,
          transparent,
          black 15%,
          black 85%,
          transparent
        );
      }

      .train-scroll {
        display: flex;
        animation: scrollTrain 30s linear infinite;
        width: max-content;
      }

      @keyframes scrollTrain {
        from {
          transform: translateX(0);
        }

        to {
          transform: translateX(-50%);
        }
      }

      .train-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0 40px;
        filter: grayscale(1);
        opacity: 0.4;
        transition: 0.4s;
      }

      .train-item:hover {
        filter: grayscale(0);
        opacity: 1;
        transform: scale(1.1);
      }

      .train-item span {
        color: #fff;
        font-family: monospace;
        font-size: 0.8rem;
        letter-spacing: 2px;
      }

      @media (max-width: 1000px) {
        .neural-engine {
          width: 100%;
          height: auto;
          perspective: none;
        }

        .node-wrapper {
          position: relative;
          animation: none;
          height: auto;
          margin: 1rem 0;
        }

        .node-anchor {
          position: relative;
          left: 0;
          transform: none;
          margin: 0 auto;
        }

        .core-hub,
        .node-laser,
        .pulse-ring,
        svg {
          display: none;
        }

        .node-card {
          animation: none !important;
          width: 320px !important;
          border-left-width: 8px;
        }
      }
    `}
  </style>
</section>

{/*------------ WORK -----------*/}
<section
  id="work"
  style={{
    backgroundColor: "#050505",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    minHeight: "100vh",
    padding: "60px 5% 100px 5%",
    fontFamily: "'Inter', sans-serif",
    overflow: "hidden",
  }}
>
  {/* AMBIENT BACKGROUND LAYER */}
  <div
    style={{
      position: "absolute",
      top: "-10%",
      right: "-5%",
      width: "500px",
      height: "500px",
      background:
        "radial-gradient(circle, rgba(127, 92, 255, 0.08) 0%, transparent 70%)",
      filter: "blur(80px)",
      zIndex: 0,
    }}
  />

  {/* HEADER */}
  <div
    style={{
      position: "relative",
      zIndex: 1,
      marginBottom: "3.5rem",
      textAlign: "center",
    }}
  >
    <h2
      style={{
        fontSize: "clamp(2rem, 10vw, 4.5rem)",
        fontWeight: "900",
        letterSpacing: "-0.04em",
        color: "#ffffff",
        margin: 0,
      }}
    >
      Handmade{" "}
      <span
        style={{
          background:
            "linear-gradient(135deg, #6a11cb, #7f5cff, #ff4d9d, #00c6ff, #00fff9)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Projects
      </span>
    </h2>

    <p
      style={{
        color: "#666",
        marginTop: "0.8rem",
        fontSize: "1.1rem",
        fontWeight: "500",
      }}
    >
      A curated showcase of technical implementations
    </p>
  </div>

  {/* GRID */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "2rem",
      width: "100%",
      maxWidth: "1300px",
      zIndex: 1,
    }}
  >
    {projects?.map((p) => (
      <div
        key={p.id}
        style={{
          background: "rgba(15, 15, 15, 0.4)",
          backdropFilter: "blur(20px)",
          borderRadius: "28px",
          padding: "1.5rem",
          border: "1px solid rgba(255,255,255,0.08)",
          display: "flex",
          flexDirection: "column",
          transition: "all 0.3s ease",
        }}
      >
        {/* PROJECT IMAGE */}
        <div
          style={{
            borderRadius: "20px",
            overflow: "hidden",
            marginBottom: "1.5rem",
          }}
        >
          <img
            src={p.image}
            alt={p.title}
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
            }}
          />
        </div>

        {/* PROJECT CONTENT */}
        <div style={{ flexGrow: 1 }}>
          <h3
            style={{
              fontSize: "1.5rem",
              color: "#fff",
              marginBottom: "0.5rem",
            }}
          >
            {p.title}
          </h3>

          <p
            style={{
              color: "#94a3b8",
              fontSize: "0.95rem",
              marginBottom: "1rem",
            }}
          >
            {p.description}
          </p>

          {/* TECH STACK */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              marginBottom: "1rem",
            }}
          >
            {p.techStack?.map((tech, i) => (
              <span
                key={i}
                style={{
                  background: "rgba(255,255,255,0.05)",
                  padding: "4px 10px",
                  borderRadius: "8px",
                  fontSize: "0.7rem",
                  color: "#ddd",
                }}
              >
                {tech}
              </span>
            ))}
          </div>
        </div>

        {/* ORGANIZATION + GITHUB */}
        <div
          style={{
            marginTop: "auto",
            paddingTop: "1rem",
            borderTop: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          <span
            style={{
              fontSize: "0.7rem",
              color: "#555",
              textTransform: "uppercase",
            }}
          >
            Organization
          </span>

          <div
            style={{
              color: "#bbb",
              fontSize: "0.85rem",
              marginBottom: "1rem",
            }}
          >
            {p.associatedWith || "Independent Lab"}
          </div>

          {/* VIEW PROJECT ON GITHUB */}
          {p.githubLink && (
            <a
              href={p.githubLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 16px",
                borderRadius: "10px",
                background:
                  "linear-gradient(135deg, #6a11cb, #7f5cff)",
                color: "#fff",
                textDecoration: "none",
                fontSize: "0.8rem",
                fontWeight: "600",
                transition: "all 0.3s ease",
              }}
            >
              View Project on GitHub ↗
            </a>
          )}
        </div>
      </div>
    ))}
  </div>




{/* ===== TESTIMONIALS ===== */}
<div
  style={{
    marginTop: "6rem",
    width: "100%",
    fontFamily: "'Inter', sans-serif",
    boxSizing: "border-box",
  }}
>
  <style>{`
    .testimonial-card {
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      background: rgba(255, 255, 255, 0.02);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.06);
      border-radius: 24px;
      transition: border-color 0.3s ease, background 0.3s ease;
      box-sizing: border-box;
    }

    .testimonial-card:hover {
      border-color: rgba(127, 92, 255, 0.3);
      background: rgba(255, 255, 255, 0.04);
    }

    .quote-icon {
      position: absolute;
      top: 15px;
      right: 20px;
      font-size: 3.5rem;
      opacity: 0.03;
      font-weight: 900;
      color: #fff;
      pointer-events: none;
    }

  
    @keyframes marqueeLeftToRight {
      0% { transform: translateX(-50%); }
      100% { transform: translateX(0%); }
    }

    @keyframes marqueeRightToLeft {
      0% { transform: translateX(0%); }
      100% { transform: translateX(-50%); }
    }

    .desktop-testimonial-view {
      display: block; /* Shown on desktop by default */
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    .desktop-testimonial-view .marquee-wrapper {
      width: 100%;
      overflow: hidden;
      margin-bottom: 1.5rem;
      position: relative;
    }

    .desktop-testimonial-view .marquee-container {
      display: flex;
      gap: 1.25rem;
      width: max-content;
    }

    .desktop-testimonial-view .track-left-to-right {
      animation: marqueeLeftToRight 35s linear infinite;
    }

    .desktop-testimonial-view .track-right-to-left {
      animation: marqueeRightToLeft 35s linear infinite;
    }

    .desktop-testimonial-view .marquee-wrapper:hover .marquee-container {
      animation-play-state: paused;
    }

    .desktop-testimonial-view .testimonial-card {
      width: 340px; 
      height: 230px;
      flex-shrink: 0;
    }

    .desktop-testimonial-view .marquee-fade-overlay {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: linear-gradient(90deg, #000 0%, transparent 12%, transparent 88%, #000 100%);
      z-index: 5;
      pointer-events: none;
    }

   
    .mobile-testimonial-view {
      display: none; /* Hidden on desktop viewports */
      width: 100%;
      max-width: 480px;
      margin: 0 auto;
      padding: 0 1.25rem;
      box-sizing: border-box;
    }

    .mobile-testimonial-view .mobile-stack {
      display: flex;
      flex-direction: column;
      gap: 1.25rem;
    }

    .mobile-testimonial-view .testimonial-card {
      width: 100%;
      min-height: 180px;
    }

  
    @media (max-width: 800px) {
      .desktop-testimonial-view {
        display: none !important; /* Kills the moving blocks on mobile completely */
      }
      .mobile-testimonial-view {
        display: block !important; /* Clean layout swap onto mobile frames */
      }
    }
  `}</style>

  {/* TITLE SECTION */}
  <div style={{ textAlign: "center", marginBottom: "3.5rem", padding: "0 1rem" }}>
    <h2
      style={{
        fontSize: "clamp(2rem, 5vw, 3.5rem)",
        fontWeight: "900",
        margin: 0,
        letterSpacing: "-2px",
        background: `
linear-gradient(
  135deg,
  #6a11cb,
  #7f5cff,
  #ff4d9d,
  #00c6ff,
  #00fff9
)
`,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      TESTIMONIALS
    </h2>
    <p style={{ color: "#8f8f8f", marginTop: "12px", fontSize: ".95rem" }}>
      Teammate & Faculty Feedback
    </p>
  </div>

  <div className="desktop-testimonial-view">
    <div className="marquee-fade-overlay" />

    {/* ROW 1: GLIDING LEFT TO RIGHT */}
    <div className="marquee-wrapper">
      <div className="marquee-container track-left-to-right">
        {[...testimonials, ...testimonials].map((t, i) => (
          <div key={`pc-l2r-${i}`} className="testimonial-card">
            <div className="quote-icon">"</div>
            <div style={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", height: "100%" }}>
              <div style={{ padding: "1.2rem 1.2rem 0.9rem 1.2rem", borderBottom: "1px solid rgba(255,255,255,.04)", display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "42px", height: "42px", borderRadius: "12px", background: "linear-gradient(135deg,#7f5cff,#ff4d9d)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "900", fontSize: "0.85rem", flexShrink: 0 }}>
                  {t.name?.charAt(0)}
                </div>
                <div style={{ overflow: "hidden" }}>
                  <h3 style={{ color: "#fff", margin: 0, fontSize: "0.9rem", fontWeight: "700", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.name}</h3>
                  <div style={{ color: "#9d9d9d", fontSize: ".75rem", marginTop: "2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.project}</div>
                </div>
              </div>
              <div style={{ padding: "1rem 1.2rem", flex: 1, overflow: "hidden" }}>
                <p style={{ color: "#d7d7d7", lineHeight: "1.6", fontSize: ".85rem", margin: 0, display: "-webkit-box", WebkitLineClamp: "4", WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {t.review}
                </p>
              </div>
              <div style={{ padding: "0.75rem 1.2rem", borderTop: "1px solid rgba(255,255,255,.04)" }}>
                <span style={{ color: "#8c8c8c", fontSize: ".7rem", letterSpacing: "0.5px" }}>{t.semester}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* ROW 2: GLIDING RIGHT TO LEFT */}
    <div className="marquee-wrapper" style={{ marginBottom: "3.5rem" }}>
      <div className="marquee-container track-right-to-left">
        {[...testimonials, ...testimonials].reverse().map((t, i) => (
          <div key={`pc-r2l-${i}`} className="testimonial-card">
            <div className="quote-icon">"</div>
            <div style={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", height: "100%" }}>
              <div style={{ padding: "1.2rem 1.2rem 0.9rem 1.2rem", borderBottom: "1px solid rgba(255,255,255,.04)", display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ width: "42px", height: "42px", borderRadius: "12px", background: "linear-gradient(135deg,#00fff9,#7f5cff)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "900", fontSize: "0.85rem", flexShrink: 0 }}>
                  {t.name?.charAt(0)}
                </div>
                <div style={{ overflow: "hidden" }}>
                  <h3 style={{ color: "#fff", margin: 0, fontSize: "0.9rem", fontWeight: "700", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.name}</h3>
                  <div style={{ color: "#9d9d9d", fontSize: ".75rem", marginTop: "2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{t.project}</div>
                </div>
              </div>
              <div style={{ padding: "1rem 1.2rem", flex: 1, overflow: "hidden" }}>
                <p style={{ color: "#d7d7d7", lineHeight: "1.6", fontSize: ".85rem", margin: 0, display: "-webkit-box", WebkitLineClamp: "4", WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                  {t.review}
                </p>
              </div>
              <div style={{ padding: "0.75rem 1.2rem", borderTop: "1px solid rgba(255,255,255,.04)" }}>
                <span style={{ color: "#8c8c8c", fontSize: ".7rem", letterSpacing: "0.5px" }}>{t.semester}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

 
  <div className="mobile-testimonial-view">
    <div className="mobile-stack">
      {testimonials.map((t, i) => (
        <div key={`mob-${i}`} className="testimonial-card">
          <div className="quote-icon">"</div>
          <div style={{ position: "relative", zIndex: 2, display: "flex", flexDirection: "column", height: "100%" }}>
            <div style={{ padding: "1rem", borderBottom: "1px solid rgba(255,255,255,.04)", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "36px", height: "36px", borderRadius: "10px", background: "linear-gradient(135deg,#7f5cff,#ff4d9d)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: "900", fontSize: "0.8rem", flexShrink: 0 }}>
                {t.name?.charAt(0)}
              </div>
              <div>
                <h3 style={{ color: "#fff", margin: 0, fontSize: "0.85rem", fontWeight: "700" }}>{t.name}</h3>
                <div style={{ color: "#9d9d9d", fontSize: ".7rem" }}>{t.project}</div>
              </div>
            </div>
            <div style={{ padding: "1rem", flex: 1 }}>
              <p style={{ color: "#d7d7d7", lineHeight: "1.5", fontSize: ".82rem", margin: 0 }}>
                {t.review}
              </p>
            </div>
            <div style={{ padding: "0.6rem 1rem", borderTop: "1px solid rgba(255,255,255,.04)" }}>
              <span style={{ color: "#8c8c8c", fontSize: ".65rem" }}>{t.semester}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
</section>



{/* ===== experience ===== */}
<section
  id="experience"
  style={{
    minHeight: "100vh",
    padding: "60px 5%", // Reduced vertical padding for mobile
    background: "#030712",
    color: "#fff",
    position: "relative",
    overflow: "hidden", // Ensures no horizontal scroll
    fontFamily: "'Inter', sans-serif",
  }}
>
  {/* Background Effects (Scaled down for mobile) */}
  <div
    style={{
      position: "absolute",
      width: "300px",
      height: "300px",
      top: "-100px",
      left: "-50px",
      borderRadius: "50%",
      background: "rgba(249, 6, 6, 0.15)",
      filter: "blur(120px)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      position: "absolute",
      width: "300px",
      height: "300px",
      bottom: "-100px",
      right: "-50px",
      borderRadius: "50%",
      background: "rgba(97, 22, 228, 0.15)",
      filter: "blur(120px)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      position: "relative",
      zIndex: 2,
    }}
  >
    {/* Header */}
    <div style={{ textAlign: "center", marginBottom: "40px" }}>
      <h2
        style={{
          fontSize: "clamp(2rem, 8vw, 4rem)", // Responsive font size
          fontWeight: "700",
          marginTop: "0",
          marginBottom: "15px",
          background:
            "linear-gradient(135deg, #6a11cb, #7f5cff, #ff4d9d, #00c6ff, #00fff9)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          display: "inline-block",
          letterSpacing: "-0.03em",
        }}
      >
        Internship Journey
      </h2>

      <p
        style={{
          color: "#94a3b8",
          maxWidth: "700px",
          margin: "0 auto",
          lineHeight: "1.6",
          fontSize: "0.95rem",
        }}
      >
        Hands-on experience in Software Development and Cybersecurity,
        contributing to real-world projects, security assessments, and
        modern application development.
      </p>
    </div>

    {/* Experience Cards (Fixed for Mobile) */}
    <div
      style={{
        display: "grid",
        // Switched 450px to 280px to allow stacking on phones
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "20px",
      }}
    >
      {/* Zoople */}
      <div
        style={{
          background: "rgba(255,255,255,.04)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,.08)",
          borderRadius: "24px",
          padding: "25px",
          boxShadow: "0 10px 40px rgba(0,0,0,.4)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", gap: "15px" }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, color: "#8b5cf6", fontSize: "1.25rem", fontWeight: "700" }}>Zoople Technologies</h3>
            <p style={{ color: "#cbd5e1", marginTop: "8px", marginBottom: "10px", fontSize: "0.9rem" }}>flutter Development Specialist Intern</p>
            <span style={{ display: "inline-block", padding: "4px 12px", borderRadius: "999px", background: "rgba(139,92,246,.15)", border: "1px solid rgba(139,92,246,.25)", color: "#c4b5fd", fontSize: "11px", fontWeight: "600" }}>📅 1.5 Months</span>
          </div>
          <div style={{ width: "60px", height: "60px", minWidth: "60px", background: "rgba(255,255,255,.06)", borderRadius: "15px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,.08)" }}>
            <img src="/certificates/zoople.png" alt="Zoople" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
          </div>
        </div>
        <ul style={{ color: "#d1d5db", lineHeight: "1.8", paddingLeft: "18px", fontSize: "0.9rem" }}>
          <li>Built responsive Flutter applications and UI components.</li>
          <li>Worked with Dart</li>
          <li>Collaborated with development teams on live projects.</li>
          <li>Applied Git version control and deployment workflows.</li>
        </ul>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "20px" }}>
          {["Flutter", "Dart", "Firebase", "Git", "REST API", "UI/UX"].map(skill => (
            <span key={skill} style={{ background: "rgba(139,92,246,.12)", border: "1px solid rgba(139,92,246,.2)", padding: "6px 12px", borderRadius: "8px", color: "#c4b5fd", fontSize: "11px" }}>{skill}</span>
          ))}
        </div>
      </div>

      {/* Cyber Security */}
      <div
        style={{
          background: "rgba(255,255,255,.04)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,.08)",
          borderRadius: "24px",
          padding: "25px",
          boxShadow: "0 10px 40px rgba(0,0,0,.4)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "20px", gap: "15px" }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, color: "#ef4444", fontSize: "1.25rem", fontWeight: "700" }}>CC Cyber Campus</h3>
            <p style={{ color: "#cbd5e1", marginTop: "8px", marginBottom: "10px", fontSize: "0.9rem" }}>Cybersecurity Intern</p>
            <span style={{ display: "inline-block", padding: "4px 12px", borderRadius: "999px", background: "rgba(239,68,68,.15)", border: "1px solid rgba(239,68,68,.25)", color: "#fca5a5", fontSize: "11px", fontWeight: "600" }}>📅 3 Months internship</span>
          </div>
          <div style={{ width: "60px", height: "60px", minWidth: "60px", background: "rgba(255,255,255,.06)", borderRadius: "15px", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,.08)" }}>
            <img src="/certificates/cc.png" alt="CC" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
          </div>
        </div>
        <ul style={{ color: "#d1d5db", lineHeight: "1.8", paddingLeft: "18px", fontSize: "0.9rem" }}>
          <li>Performed website penetration testing and security audits.</li>
          <li>Conducted OSINT and reconnaissance activities.</li>
          <li>Identified vulnerabilities and security misconfigurations.</li>
          <li>Analyzed network traffic and security threats.</li>
        </ul>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "20px" }}>
          {["Nmap", "Wireshark", "Burp Suite", "Metasploit", "Kali", "Nessus"].map(tool => (
            <span key={tool} style={{ background: "rgba(239,68,68,.12)", border: "1px solid rgba(239,68,68,.2)", padding: "6px 12px", borderRadius: "8px", color: "#fca5a5", fontSize: "11px" }}>{tool}</span>
          ))}
        </div>
      </div>
    </div>

    {/* Metrics */}
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "15px", marginTop: "40px" }}>
      {[
        { value: "02", label: "Internships" },
        { value: "4.5", label: "Months Exp" },
        { value: "9+", label: "Tools" },
        { value: "5", label: "Projects" },
        { value: "40+", label: "Labs" },
      ].map((item) => (
        <div key={item.label} style={{ background: "rgba(255,255,255,.03)", border: "1px solid rgba(255,255,255,.08)", borderRadius: "20px", padding: "20px", textAlign: "center" }}>
          <h3 style={{ fontSize: "1.5rem", margin: 0, background: "linear-gradient(90deg,#8b5cf6,#ef4444)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>{item.value}</h3>
          <p style={{ color: "#94a3b8", fontSize: "0.8rem", marginTop: "5px" }}>{item.label}</p>
        </div>
      ))}
    </div>
  </div>
</section>






{/* ===== Cybersecurity Project ===== */}
<section
  id="reports"
  style={{
    padding: "clamp(60px,8vw,100px) 5%",
    background: "#030712",
    color: "#fff",
    fontFamily: "'Inter', sans-serif",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* Background Glow - Added float animation */}
  <div
    className="blob-float"
    style={{
      position: "absolute",
      top: "-250px",
      left: "-200px",
      width: "500px",
      height: "500px",
      borderRadius: "50%",
      background: "rgba(127,92,255,.15)",
      filter: "blur(120px)",
      pointerEvents: "none",
      animation: "floatGlow 8s ease-in-out infinite alternate",
    }}
  />

  <div
    className="blob-float"
    style={{
      position: "absolute",
      bottom: "-250px",
      right: "-200px",
      width: "500px",
      height: "400px",
      borderRadius: "50%",
      background: "rgba(0,198,255,.12)",
      filter: "blur(120px)",
      pointerEvents: "none",
      animation: "floatGlowInverse 10s ease-in-out infinite alternate",
    }}
  />

  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      position: "relative",
      zIndex: 2,
    }}
  >
    {/* Header - Added fade-in animation */}
    <div
      className="fade-in-up"
      style={{
        textAlign: "center",
        marginBottom: "60px",
      }}
    >
      <span
        style={{
          color: "#7f5cff",
          textTransform: "uppercase",
          letterSpacing: "3px",
          fontSize: "13px",
          fontWeight: "600",
        }}
      >
        Cybersecurity Internship Project
      </span>

      <h2
        style={{
          fontSize: "clamp(2.2rem,5vw,4rem)",
          fontWeight: "700",
          marginTop: "10px",
          marginBottom: "20px",
          lineHeight: "1.15",
          background:
            "linear-gradient(135deg,#6a11cb,#7f5cff,#ff4d9d,#00c6ff,#00fff9)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Website Penetration Testing
      </h2>

      <p
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          color: "#94a3b8",
          lineHeight: "1.8",
          fontSize: "clamp(14px,2vw,17px)",
        }}
      >
        Web application security assessment during my
        internship at CC Cyber Campus. The engagement included reconnaissance,
        vulnerability discovery, authentication testing, risk analysis, and
        security reporting.
      </p>
    </div>

    {/* Main Card */}
    <div
      className="fade-in-up"
      style={{
        background: "rgba(255,255,255,.04)",
        backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,.08)",
        borderRadius: "28px",
        padding: "clamp(18px,3vw,32px)",
        boxShadow: "0 20px 50px rgba(0,0,0,.4)",
      }}
    >
      {/* Stats */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))",
          gap: "16px",
          marginBottom: "40px",
        }}
      >
        {[
          { value: "12", label: "Assets Tested" },
          { value: "04", label: "Findings" },
          { value: "02", label: "High Risk Issue" },
          { value: "94%", label: "Coverage" },
        ].map((item, index) => (
          <div
            key={item.label}
            className="report-card stagger-anim"
            style={{
              background: "rgba(255,255,255,.03)",
              border: "1px solid rgba(255,255,255,.08)",
              borderRadius: "18px",
              padding: "22px",
              textAlign: "center",
              transition: ".3s",
              animationDelay: `${index * 0.1}s`,
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "clamp(1.5rem,4vw,2rem)",
                color: "#7f5cff",
              }}
            >
              {item.value}
            </h3>

            <p
              style={{
                color: "#94a3b8",
                marginTop: "10px",
              }}
            >
              {item.label}
            </p>
          </div>
        ))}
      </div>

      {/* Content Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
          gap: "30px",
        }}
      >
        {/* Methodology */}
        <div>
          <h3
            style={{
              color: "#7f5cff",
              marginBottom: "20px",
            }}
          >
            Methodology
          </h3>

          {[
            "Reconnaissance & OSINT",
            "Subdomain Enumeration",
            "Authentication Testing",
            "Configuration Review",
            "Manual Validation",
          ].map((item, index) => (
            <div
              key={item}
              className="report-card stagger-anim"
              style={{
                padding: "14px 16px",
                marginBottom: "12px",
                borderRadius: "14px",
                background: "rgba(255,255,255,.03)",
                border: "1px solid rgba(255,255,255,.05)",
                transition: ".3s",
                animationDelay: `${0.4 + index * 0.1}s`,
              }}
            >
              {item}
            </div>
          ))}
        </div>

        {/* Findings */}
        <div>
          <h3
            style={{
              color: "#ff4d9d",
              marginBottom: "20px",
            }}
          >
            Key Findings
          </h3>

          {[
            "Information Disclosure",
            "Admin Interface Exposure",
            "Clickjacking Vulnerability",
          ].map((item, index) => (
            <div
              key={item}
              className="report-card stagger-anim"
              style={{
                padding: "14px 16px",
                marginBottom: "12px",
                borderRadius: "14px",
                background: "rgba(255,255,255,.03)",
                borderLeft: "4px solid #ff4d9d",
                transition: ".3s",
                animationDelay: `${0.6 + index * 0.1}s`,
              }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* Tools */}
      <div style={{ marginTop: "40px" }}>
        <h3
          style={{
            color: "#00c6ff",
            marginBottom: "20px",
          }}
        >
          Tools Used
        </h3>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          {[
            "Nmap",
            "Wireshark",
            "Burp Suite",
            "Metasploit",
            "Kali Linux",
            "Nessus",
            "OWASP",
          ].map((tool, index) => (
            <span
              key={tool}
              className="tool-badge stagger-anim"
              style={{
                padding: "8px 14px",
                borderRadius: "12px",
                background: "rgba(0,198,255,.08)",
                border: "1px solid rgba(0,198,255,.2)",
                color: "#7dd3fc",
                fontSize: "14px",
                transition: ".3s",
                animationDelay: `${0.8 + index * 0.05}s`,
                display: "inline-block",
              }}
            >
              {tool}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>

  <style>{`
    #reports * {
      box-sizing: border-box;
    }

    .report-card:hover {
      transform: translateY(-5px);
      border-color: rgba(127,92,255,.25);
      box-shadow: 0 10px 30px rgba(127,92,255,.15);
    }

    .tool-badge {
      transition: .3s;
    }

    .tool-badge:hover {
      transform: translateY(-3px);
      background: rgba(0,198,255,.15);
    }

    /* Animation Keyframes */
    @keyframes floatGlow {
      0% {
        transform: translate(0, 0) scale(1);
      }

      100% {
        transform: translate(30px, -20px) scale(1.05);
      }
    }

    @keyframes floatGlowInverse {
      0% {
        transform: translate(0, 0) scale(1);
      }

      100% {
        transform: translate(-30px, 20px) scale(1.05);
      }
    }

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }

      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    .fade-in-up {
      animation: fadeInUp 1s ease-out forwards;
    }

    .stagger-anim {
      opacity: 0;
      animation: fadeInUp 0.8s ease-out forwards;
    }

    @media (max-width: 768px) {
      #reports {
        padding: 60px 20px !important;
      }

      #reports h2 {
        line-height: 1.15;
      }

      #reports h3 {
        font-size: 1.05rem !important;
      }
    }

    @media (max-width: 480px) {
      #reports {
        padding: 50px 16px !important;
      }

      .tool-badge {
        font-size: 13px !important;
        padding: 8px 12px !important;
      }
    }
  `}</style>
</section>




{/* ===== Moments of Growth===== */}
<section
  id="Moments of Growth"
  style={{
    padding: "80px 5%",
    background: "#030712",
    color: "#fff",
    fontFamily: "'Inter', sans-serif",
    position: "relative",
    overflow: "hidden",
  }}
>
  {/* BACKGROUND GLOW */}

  <div
    style={{
      position: "absolute",
      top: "-180px",
      left: "-180px",
      width: "450px",
      height: "450px",
      borderRadius: "50%",
      background: "rgba(127,92,255,.12)",
      filter: "blur(120px)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      position: "absolute",
      bottom: "-180px",
      right: "-180px",
      width: "450px",
      height: "450px",
      borderRadius: "50%",
      background: "rgba(0,198,255,.08)",
      filter: "blur(120px)",
      pointerEvents: "none",
    }}
  />

  <div
    style={{
      maxWidth: "1300px",
      margin: "0 auto",
      position: "relative",
      zIndex: 2,
    }}
  >
    {/* HEADER */}

    <div
      style={{
        textAlign: "center",
        marginBottom: "50px",
      }}
    >
      <span
        style={{
          color: "#7f5cff",
          textTransform: "uppercase",
          letterSpacing: "3px",
          fontSize: "13px",
          fontWeight: "700",
        }}
      >
        showcase
      </span>

      <h2
        style={{
          fontSize: "clamp(2.1rem, 5vw, 3rem)",
          fontWeight: "800",
          margin: "10px 0",
          background:
            "linear-gradient(135deg,#6a11cb,#7f5cff,#ff4d9d,#00c6ff)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Moments
      </h2>
    </div>

    {/* ========================================= */}
    {/* ROW 1 — FOUR IMAGES */}
    {/* ========================================= */}

    <div className="achievement-row-four">

      {/* PHOTO 01 */}
      <div className="achievement-card">
        <img
          src={cccyber}
          alt="Achievement 1"
        />
      </div>

      {/* PHOTO 02 */}
       <div className="achievement-card">
        <img
          src={cc}
          alt="Achievement 2"
        />
      </div>

   {/* PHOTO 03 */}
       <div className="achievement-card">
        <img
          src={off}
          alt="Achievement 3"
        />
      </div>

      {/* PHOTO 04 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 04
        </div>
      </div>

    </div>

    {/* ========================================= */}
    {/* ROW 2 — THREE IMAGES */}
    {/* ========================================= */}

    <div className="achievement-row-three">

      {/* PHOTO 05 */}
    <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 06
        </div>
      </div>

      {/* PHOTO 06 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 06
        </div>
      </div>

      {/* PHOTO 07 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 07
        </div>
      </div>

    </div>

    {/* ========================================= */}
    {/* ROW 3 — FOUR IMAGES */}
    {/* ========================================= */}

    <div className="achievement-row-four">

      {/* PHOTO 08 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 08
        </div>
      </div>

      {/* PHOTO 09 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 09
        </div>
      </div>

      {/* PHOTO 10 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 10
        </div>
      </div>

      {/* PHOTO 11 */}
      <div className="achievement-card">
        <div className="achievement-empty">
          PHOTO 11
        </div>
      </div>

    </div>
  </div>

  {/* ===== ACHIEVEMENTS CSS ===== */}

  <style>{`

    #achievements * {
      box-sizing: border-box;
    }

    /* FOUR IMAGE ROW */

    .achievement-row-four {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 18px;
      margin-bottom: 18px;
    }

    /* THREE IMAGE ROW */

    .achievement-row-three {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 18px;
      margin-bottom: 18px;
    }

    /* PHOTO CARD */

    .achievement-card {
      position: relative;
      height: 280px;
      overflow: hidden;
      border-radius: 22px;
      background: #0b0f19;
      border: 1px solid rgba(255,255,255,.08);
      transition:
        transform .4s ease,
        border-color .4s ease,
        box-shadow .4s ease;
    }

    /* REAL IMAGE */

    .achievement-card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition:
        transform .5s ease,
        filter .5s ease;
    }

    /* HOVER */

    .achievement-card:hover {
      transform: translateY(-6px);
      border-color: rgba(127,92,255,.45);
      box-shadow:
        0 20px 50px rgba(0,0,0,.4);
    }

    .achievement-card:hover img {
      transform: scale(1.06);
      filter: brightness(.82);
    }

    /* EMPTY PHOTO PLACEHOLDER */

    .achievement-empty {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255,255,255,.18);
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 2px;
      background:
        linear-gradient(
          135deg,
          rgba(127,92,255,.04),
          rgba(0,198,255,.03)
        );
    }

    /* TABLET */

    @media (max-width: 900px) {

      .achievement-row-four {
        grid-template-columns: repeat(2, 1fr);
      }

      .achievement-row-three {
        grid-template-columns: repeat(2, 1fr);
      }
    }

    /* MOBILE */

    @media (max-width: 600px) {

      #achievements {
        padding: 60px 16px !important;
      }

      .achievement-row-four,
      .achievement-row-three {
        grid-template-columns: 1fr;
        gap: 12px;
      }

      .achievement-card {
        height: 280px;
        border-radius: 18px;
      }
    }

  `}</style>
</section>



        
{/* ----------- CERTIFICATES SECTION ---------- */}
<section
  id="certifications"
  style={{
    minHeight: "100vh",
    padding: "2.5rem 5% 5rem",
    background: "#030303",
    fontFamily: "'Inter', sans-serif",
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    scrollMarginTop: "80px",
  }}
>
  {/* Background Glow */}
  <div
    style={{
      position: "absolute",
      top: "20%",
      left: "50%",
      width: "400px",
      height: "400px",
      background:
        "radial-gradient(circle, rgba(127, 92, 255, 0.15) 0%, transparent 70%)",
      transform: "translate(-50%, -50%)",
      zIndex: 0,
      pointerEvents: "none",
    }}
  />

  {/* Header */}
  <div
    style={{
      textAlign: "center",
      marginBottom: "3rem",
      position: "relative",
      zIndex: 1,
    }}
  >
    <h2
      style={{
        fontSize: "clamp(2.5rem, 6vw, 4rem)",
        fontWeight: "800",
        margin: 0,
        background:
          "linear-gradient(135deg, #6a11cb, #7f5cff, #ff4d9d, #00c6ff, #00fff9)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      Certifications
    </h2>

    <div
      style={{
        height: "4px",
        width: "60px",
        background:
          "linear-gradient(90deg, #7f5cff, #ff4d9d)",
        margin: "15px auto",
        borderRadius: "10px",
      }}
    />
  </div>

  {/* Grid */}
  <div
    className="cert-grid"
    style={{
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit, minmax(320px, 1fr))",
      gap: "30px",
      maxWidth: "1200px",
      margin: "auto",
      position: "relative",
      zIndex: 1,
    }}
  >
    {[
      {
        title: "Academic Excellence",
        subtitle: "Education Degrees",
        index: 0,
        groupName: "education",
        icon: "🎓",
      },
      {
        title: "Technical Mastery",
        subtitle: "Skill Certifications",
        index: 4,
        groupName: "skills",
        icon: "⚡",
      },
    ].map((item, i) => (
      <div
        key={i}
        onClick={() => {
          setGroup(item.groupName);
          setModalIndex(0);
        }}
        className="cert-card"
        style={{
          position: "relative",
          borderRadius: "24px",
          overflow: "hidden",
          cursor: "pointer",
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.1)",
          transition: "all 0.35s ease",
        }}
      >
        {/* Preview Image */}
        <div
          style={{
            height: "260px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={certificates[item.index]}
            alt={item.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "blur(4px)",
              transition: "transform 0.4s ease",
            }}
          />

          {/* Icon */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              zIndex: 2,
            }}
          >
            <span
              style={{
                fontSize: "clamp(60px, 10vw, 90px)",
              }}
            >
              {item.icon}
            </span>

            <span
              style={{
                fontSize: "12px",
                fontWeight: "700",
                textTransform: "uppercase",
                letterSpacing: "1.5px",
                color: "#fff",
                background: "rgba(0,0,0,0.6)",
                padding: "6px 14px",
                borderRadius: "20px",
                border:
                  "1px solid rgba(255,255,255,0.2)",
              }}
            >
              Click Here
            </span>
          </div>
        </div>

        {/* Content */}
        <div
          style={{
            padding: "22px",
            textAlign: "center",
            background: "rgba(3,3,3,0.85)",
          }}
        >
          <h3
            style={{
              fontSize: "clamp(18px, 3vw, 24px)",
              fontWeight: "600",
              margin: "0 0 8px",
            }}
          >
            {item.title}
          </h3>

          <p
            style={{
              color: "#aaa",
              fontSize: "14px",
              margin: 0,
            }}
          >
            {item.subtitle}
          </p>
        </div>
      </div>
    ))}
  </div>

  {/* Modal */}
  {group && (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(3,3,3,0.98)",
        backdropFilter: "blur(12px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
    >
      {/* Close */}
      <button
        onClick={() => setGroup(null)}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          border: "none",
          background: "rgba(255,255,255,0.08)",
          color: "#fff",
          fontSize: "20px",
          cursor: "pointer",
          zIndex: 10,
        }}
      >
        ✕
      </button>

      {/* Images */}
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "1000px",
          height: "75vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {activeArray.map((certIndex, i) => (
          <img
            key={certIndex}
            src={certificates[certIndex]}
            alt={certificatesNames[certIndex]}
            style={{
              position: "absolute",
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              borderRadius: "12px",
              boxShadow:
                "0 25px 60px rgba(0,0,0,0.7)",
              opacity: i === modalIndex ? 1 : 0,
              transition: "opacity 0.4s ease",
              pointerEvents:
                i === modalIndex ? "auto" : "none",
            }}
          />
        ))}
      </div>

      {/* Left Arrow */}
      <button
        onClick={(e) => {
          e.stopPropagation();

          setModalIndex(
            (modalIndex - 1 + activeArray.length) %
              activeArray.length
          );
        }}
        style={{
          position: "absolute",
          left: "15px",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          border:
            "1px solid rgba(255,255,255,0.15)",
          background: "rgba(255,255,255,0.08)",
          color: "#fff",
          fontSize: "24px",
          cursor: "pointer",
        }}
      >
        ❮
      </button>

      {/* Right Arrow */}
      <button
        onClick={(e) => {
          e.stopPropagation();

          setModalIndex(
            (modalIndex + 1) % activeArray.length
          );
        }}
        style={{
          position: "absolute",
          right: "15px",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          border:
            "1px solid rgba(255,255,255,0.15)",
          background: "rgba(255,255,255,0.08)",
          color: "#fff",
          fontSize: "24px",
          cursor: "pointer",
        }}
      >
        ❯
      </button>

      {/* Certificate Name */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          textAlign: "center",
          padding: "0 20px",
          width: "100%",
        }}
      >
        <h4
          style={{
            fontSize: "clamp(14px, 2vw, 20px)",
            fontWeight: "500",
            color: "#fff",
          }}
        >
          {certificatesNames[activeArray[modalIndex]]}
        </h4>
      </div>
    </div>
  )}

  {/* Responsive Styles */}
  <style>
    {`
      .cert-card:hover {
        transform: translateY(-10px);
        border-color: rgba(127,92,255,0.4);
        box-shadow: 0 20px 50px rgba(127,92,255,0.15);
      }

      .cert-card:hover img {
        transform: scale(1.05);
      }

      @media (max-width: 768px) {
        .cert-grid {
          grid-template-columns: 1fr !important;
        }
      }

      @media (max-width: 600px) {
        #certifications {
          padding: 2rem 20px 4rem !important;
        }

        .cert-card {
          border-radius: 18px !important;
        }
      }
    `}
  </style>
</section>

   {/* Contact */}
    <ContactSection />

              {/* Footer stays at bottom */}
        <footer
          style={{
            textAlign: "center",
            padding: "1rem",
            backgroundColor: "#007bff",
            width:'108%',
            color: "white",
            fontWeight: "500",
            fontSize: "1rem",
            letterSpacing: "0.5px",
            boxShadow: "0 -2px 15px rgba(0, 123, 255, 0.3)",
          }}
        >
           <b>Ashwinn B Menon</b> Portfolio
        </footer>
          </div>
        } />
        <Route path="/projects/:id" element={<ProjectDetails projects={projects} />} />
      </Routes>
    </Router>
  );
}

export default App;
